<div class="connectivity-table-container">
  <table class="table" *ngIf="data && tableConfig?.Columns?.length > 0">
    <thead>
      <tr class="table-header">
        <th *ngFor="let col of tableConfig?.Columns"
          [style.width]="col.Width"
          [style.textAlign]="getAlignment(col.Alignment) || 'center'">
          {{ col.Title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of tableConfig?.Content; let i = index"
        class="table-row"
        [style.background]="(row.BackgroundColor !== null) ? rgbToHexa(row.BackgroundColor) : null">
        <td *ngFor="let col of tableConfig.Columns"
          [style.text-align]="getAlignment(col.Alignment)"
          class="table-cell">
          <div *ngIf="col.Key === 'Period'" class="period-cell">
            <span class="period-text">{{ row.Data[col.Key] }}</span>
            <i class="fa fa-download text-white" style="cursor: pointer;"></i>
          </div>
          <span *ngIf="col.Key !== 'Period'">{{ row.Data[col.Key] }}</span>
        </td>
      </tr>
    </tbody>
  </table>

</div>
<div class="text-center" *ngIf="tableConfig?.Content === null">
  <i class="fas fa-circle-notch fa-spin fa-2x"></i>
</div>